import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    search: {
        url: `${customerApi}/api/lost_customers/search`,
        type: 'POST',
    },
    exportTaskId: {
        url: `${customerApi}/api/lost_customers/export`,
        type: 'POST',
    },
}
